import _ from 'lodash';
import { IValidatorFactoryService } from './validator-factory.service';
import { INumberMetadata } from 'app/extensibility/metadatas/validator/number-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

/**
 * DO NOT USE THIS!
 * @deprecated Please use the new NumberValidatorFactoryService from shell-models-lib
 */
export class NumberValidatorFactoryService implements IValidatorFactoryService<INumberMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'number';

    public createValidatorByMetadata(metadata: INumberMetadata): IValidatorFn {
        return this.createValidator(metadata.min, metadata.max, metadata.errorMessage);
    }
    public createValidator(min: number = -Number.MAX_VALUE, max: number = Number.MAX_VALUE, errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.Validator_ErrorMessage_Number;
        return (value: number) => {
            return (!value && value !== 0) || (_.isFinite(+value) && (value >= min) && (value <= max)) ? null : errorMessage;
        };
    }
}
